import React, { useState } from 'react'
import { Card, CardBody, CardFooter, Col, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import CustomToast from '../../../utils/CustomToast';
import DownloadIcon from 'assets/img/bis/download-icon.png';
import axios from 'axios';
import useSiteCookies from '../useSiteCookies';

const FileUploaderModal = ({ show, onHide, instance, onData }) => {
    const { currentUser, token } = useSiteCookies();

    const [formStatus, setFormStatus] = useState(false);
    const [uploadedFileError, setUploadedFileError] = useState(false);
    const [uploadedFile, setUploadedFile] = useState('Upload file here');

    const [item, setItem] = useState({ name: '', value: '' });

    const uploadInstanceLabel = {
        document: 'DOCUMENT',
        logo: 'LOGO',
        photo_1: 'PHOTO 1',
        photo_2: 'PHOTO 2',
    };

    const hiddenFileInputPdf = React.useRef(null);

    const postUpload = async (data) => {
        return await axios.post(
            process.env.REACT_APP_API_ENDPOINT + `entry/document`, data, {
            params: {
                user_id: currentUser,
                token: token
            }
        });
    }

    const postLogo = async (data) => {
        return await axios.post(
            process.env.REACT_APP_API_ENDPOINT + `entry/logo`, data, {
            params: {
                user_id: currentUser,
                token: token
            }
        });
    }

    const handleClickFile = () => {
    hiddenFileInputPdf.current.click();
    };

    const handleDragEnter = e => {
        e.preventDefault();
    };

    const handleDragOver = e => {
        e.preventDefault();
    };

    const handleDragLeave = e => {
        e.preventDefault();
    };

    const handleDrop = e => {
        e.preventDefault();
    
        const droppedFiles = e.dataTransfer.files;
        const totalFilesCount = droppedFiles.length;
    
        if (totalFilesCount > 1) {
            const message = "This field accepts only 1 image!";
            CustomToast.warning(message);
            return;
        }
    
        if (formStatus)
            return;
    
        setFormStatus(true);
    
        if (droppedFiles[0]) {
            const file = droppedFiles[0];
            const size = file.size;
        
            if (instance === 'document') pdfValidations(file, size);
        }
    };

    const handleChangeFiles = ({ target }) => {
        if (target.files < 1 || !target.validity.valid) {
          return;
        }

        setFormStatus(true);
    
        if (target.files[0]) {
            const file = target.files[0];
            const size = file.size;
        
            if (instance === 'document') pdfValidations(file, size);
            else logoValidations(file);
        }
    };

    const pdfValidations = (file, size) => {
        if (file.type !== 'application/pdf') {
            CustomToast.warning('File should be pdf!');
            setFormStatus(false);
        } else {
            if (size / 1024 > 50000) {
                CustomToast.warning('Pdf file must not be higher than 50mb!');
                setFormStatus(false);
            } else {
                submitFile(file);
                setUploadedFileError(false);
            }
        }
    };

    const logoValidations = file => {
        if (file.type.includes('image')) {
            submitLogo(file);
            setUploadedFileError(false);
        } else {
          setFormStatus(false);
          CustomToast.warning('Logo must be image!');
        }
    };

    const submitFile = (file) => {
        setFormStatus(true);
        const dataArray = new FormData();
        dataArray.append('document', file);
        dataArray.append('other_document', '0');
        
        postUpload(dataArray).then(response => {
            const status = response.data.status;
            if (status === 'Success') {
                setFormStatus(false);
                setUploadedFile(file.name);

                const data = response.data.data;
                if (data) {
                    setItem({ name: 'document', value: data.document })
                }
            } else {
                CustomToast.defaultError();
                setFormStatus(false);
            }
        }).catch(() => {  
            CustomToast.defaultError();
            setFormStatus(false);
        });
    }

    const submitLogo = (file) => {
        setFormStatus(true);
        const dataArray = new FormData();
        dataArray.append('logo', file);
        
        postLogo(dataArray).then(response => {
            const status = response.data.status;
            if (status === 'Success') {
                setFormStatus(false);
                setUploadedFile(file.name);

                const data = response.data.data;
                if (data) {
                    if(instance) {
                        if(instance == 'photo_1') {
                            setItem({ name: 'photo_1', value: data.logo })
                        } else if (instance == 'photo_2') {
                            setItem({ name: 'photo_2', value: data.logo })
                        } else if (instance == 'logo') {
                            setItem({ name: 'logo', value: data.logo })
                        }  
                    }
                }
            } else {
                CustomToast.defaultError();
                setFormStatus(false);
            }
        }).catch(() => {  
            CustomToast.defaultError();
            setFormStatus(false);
        });
    }

    const handleUpload = () => {
        if (item.value === '') {
            setUploadedFileError(true);
            setFormStatus(false);
            return;
        } else {
            onData({ target: item });
            onHide();
            setUploadedFile('Upload file here');
        }
    }

    const toggleHide = () => {
        onHide();
        setItem({ name: '', value: '' });
        setUploadedFile('Upload file here');
        setUploadedFileError(false);
    }

    return (
        <>
            <Modal
                isOpen={show}
                className="modal-preview"
                fade={false}
                centered
                id="edit-judge-modal"
            >
            <ModalHeader className="text-left">
                UPLOAD {uploadInstanceLabel[instance]}
                {!formStatus && (
                <button
                    type="button"
                    className="close react-modal-close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={() => toggleHide()}
                >
                    <span aria-hidden="true">&times;</span>
                </button>
                )}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col lg="12">
                        <Card>
                            <CardBody className="card_container">
                                <Label
                                    onClick={handleClickFile}
                                    onDragEnter={handleDragEnter}
                                    onDragOver={handleDragOver}
                                    onDragLeave={handleDragLeave}
                                    onDrop={handleDrop}
                                    className={`${uploadedFileError
                                        ? 'download_icon form-invalid'
                                        : 'download_icon'
                                        }`}
                                    style={
                                        formStatus
                                        ? { cursor: 'not-allowed', opacity: '0.5' }
                                        : {}
                                    }
                                >
                                    <img src={DownloadIcon} />
                                    <br />
                                    {uploadedFile}
                                </Label>
                                {uploadedFileError ? (
                                    <p role="alert" className="invalid-feedback">
                                        File is required
                                    </p>
                                ) : null}
                                <input
                                    type="file"
                                    ref={hiddenFileInputPdf}
                                    accept={
                                        instance === 'document'
                                        ? 'application/pdf'
                                        : 'image/*'
                                    }
                                    onChange={handleChangeFiles}
                                    style={{ display: 'none' }}
                                    required
                                    disabled={formStatus}
                                />
                            </CardBody>
                            <CardFooter className="text-right">
                                {!formStatus && (
                                <button
                                    type="button"
                                    className="btn btn-main btn-main-alt mr-2"
                                    data-dismiss="modal"
                                    onClick={() => toggleHide()}
                                >
                                    CLOSE
                                </button>
                                )}
                                {!formStatus ? (
                                <button
                                    type="button"
                                    className="newbuttontheme w-25"
                                    onClick={handleUpload}
                                >
                                    SAVE
                                </button>
                                ) : (
                                <button
                                    type="button"
                                    className="newbuttontheme w-25"
                                >
                                    UPLOADING...
                                </button>
                                )}
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
            </ModalBody>
            </Modal>
        </>
    )
}

export default FileUploaderModal